// extracted by mini-css-extract-plugin
export default {"btn":"foodRestriction_btn__5BlKT","prev":"foodRestriction_prev__Swy9V","nxt":"foodRestriction_nxt__1CbTq"};